<div class="card document-settings-page settings-page">
  <div class="action-panel">
    <app-button
      *appHasRole="['Admin', 'Manager']"
      id="add-tag-dd"
      text="Edit"
      iconClass="icon ic-edit-20"
      (clickBtn)="openEditDocumentSettingsModal()"
    />
  </div>

  <div class="document-settings-page-content">
    @if (!isLoading()) {
      <div class="documents-part">
        <div class="part-title">eSigning</div>
        <div class="grid">
          <div class="form-group">
            <label class="title mb-1">Receive email for eSigned documents</label>
            <div class="property">
              <div appCopy>
                {{ NotifyWhenAllPartiesSignedDocumentLabelRecord[documentSettings.esigningEmailRecipients] | defaultValue }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="annual-statement-part">
        <div class="part-title">Annual Statement</div>

        <div class="grid">
          <div class="form-group">
            <label class="title mb-1">Do you want to generate an annual statement automatically?</label>
            <div class="property">
              {{ asSettings.generateAutomatically ? 'Yes' : 'No' }}
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Do you want to add Director's Signature to the Company Statement?</label>
            <div class="property">
              {{ asSettings.addSignatoryToCompanyStatement ? 'Yes' : 'No' }}
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Type of document to generate</label>
            <div class="property">
              <div appCopy>{{ DocumentationType[asSettings.documentTypeToGenerate] | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Meeting address type</label>
            <div class="property">
              <div appCopy>{{ MeetingLocationType[asSettings.meetingLocationType] }}</div>
            </div>
          </div>

          @if (asSettings.meetingLocationType == MeetingLocationType.Online) {
            <div class="form-group">
              <label class="title mb-1">Metting online type</label>
              <div class="property">
                <div appCopy>{{ MeetingOnlineType[asSettings.meetingOnlineType ?? 0] }}</div>
              </div>
            </div>
          }

          @if (asSettings.meetingLocationType == MeetingLocationType.Other) {
            <div class="form-group">
              <label class="title mb-1">Metting other address</label>
              <div class="property">
                <div appCopy>{{ asSettings.otherAddress?.normalizedFullAddress ?? 'N/A' }}</div>
              </div>
            </div>
          }
        </div>

        <div class="document-selection">
          <app-document-selection
            title="Documents to Generate"
            [documentSelectionList]="asSettings.documentSelectionFiles.length == 0 ? initDocumentSelectionFiles : asSettings.documentSelectionFiles"
            [documentationType]="asSettings.documentTypeToGenerate"
            [isDisabled]="true"
          />
        </div>
      </div>
    }

    <app-loader [loading]="isLoading()"/>
  </div>
</div>
